import React from "react";
import "./TypeaheadClearButtonComponent.scss";

interface TypeaheadClearButtonProps {
  onMouseDown: () => void;
  disabled?: boolean;
}

const TypeaheadClearButton = ({ onMouseDown, disabled }: TypeaheadClearButtonProps) => (
  <button
    disabled={disabled}
    type="button"
    onMouseDown={onMouseDown}
    className="sid-input-clear-button"
    aria-label="clear text"
  >
    <svg
      viewBox="0 0 24 24"
      preserveAspectRatio="none"
      width={28}
      fill="none"
      stroke={disabled ? "#B6B6B6" : "#5A5A5A"}
      strokeWidth="1.1"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
);

export const TypeaheadClearButtonComponent = TypeaheadClearButton;
